export const handleValidationError = (error: any): string | undefined => {
  if (error.message === 'Ошибка валидации') {
    const processErrors = (errors: any[]): string[] => {
      return errors.flatMap(err => {
        const messages: string[] = [];
        
        if (err.constraints) {
          messages.push(...Object.values(err.constraints) as string[]);
        }
        
        if (err.children && err.children.length > 0) {
          messages.push(...processErrors(err.children));
        }
        
        return messages;
      });
    };

    return processErrors(error.data?.errors || error.errors).join('\n');
  }

  return error.message;
}
